import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../Components/Navigation';
import '../../Assets/Styles/BlogPage.css';

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch blog data from API
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://tstock.trillionstechsolutions.com/blogs-edits/all');
        
        if (!response.ok) {
          throw new Error('Failed to fetch blogs');
        }
        
        const result = await response.json();
        
        if (result.success) {
          setBlogs(result.data);
        } else {
          throw new Error(result.error || 'Failed to fetch blogs');
        }
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setError('Failed to load blog posts. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter(blog => {
    const matchesFilter = filter === 'all' || blog.category.toLowerCase() === filter.toLowerCase();
    const matchesSearch = blog.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                         blog.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (blog.tags && blog.tags.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesFilter && matchesSearch;
  });

  const categories = ['all', ...new Set(blogs.map(blog => blog.category))];

  return (
    <div className="blog-page-container">
      <Navigation />
      <div className="blog-page-content">
        <div className="blog-page-header">
          <h1>Blog Posts</h1>
          <p>Explore our latest insights and articles on finance, investment, and market trends</p>
        </div>

        <div className="blog-filters">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search blogs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
          
          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category}
                className={`category-btn ${filter === category ? 'active' : ''}`}
                onClick={() => setFilter(category)}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="loading-spinner">Loading blogs...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : (
          <div className="blog-grid">
            {filteredBlogs.length > 0 ? (
              filteredBlogs.map(blog => (
                <div key={blog._id} className="blog-card">
                  <div className="blog-image">
                    <img src={`https://tstock.trillionstechsolutions.com${blog.featuredImage}`} alt={blog.title} />
                    <div className="blog-category">{blog.category}</div>
                  </div>
                  
                  <div className="blog-content">
                    <h2 className="blog-title">{blog.title}</h2>
                    <p className="blog-excerpt">{blog.excerpt}</p>
                    
                    <div className="blog-meta">
                      <div className="meta-item">
                        <span className="meta-icon">👤</span>
                        <span>{blog.author}</span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-icon">📅</span>
                        <span>{new Date(blog.createdAt).toLocaleDateString()}</span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-icon">👁️</span>
                        <span>{blog.views} views</span>
                      </div>
                    </div>
                    
                    <div className="blog-tags">
                      {blog.tags && blog.tags.split(',').map(tag => (
                        <span key={tag.trim()} className="blog-tag">#{tag.trim()}</span>
                      ))}
                    </div>
                    
                    <Link to={`/edit-blog/${blog._id}`} className="read-more-btn">
                      Edit Blog
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">
                <h3>No blogs found</h3>
                <p>Try adjusting your search or filter criteria</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPage;
